import { FormStepProps } from 'hooks/stepper.hook'
import { StepIndex, StepLabel, StepPath } from '../enums/step.enum'
import { useNewHearing } from './hearing.hook'

export const useHearingForms = (id?: string) => {
  const { hearingId, isFinalized } = useNewHearing(id)

  const formSteps: FormStepProps[] = [
    {
      index: StepIndex.DADOS_GERAIS,
      title: StepLabel.DADOS_GERAIS,
      path: StepPath.DADOS_GERAIS,
    },
    {
      index: StepIndex.IDENTIFICACAO_ADOLESCENTE,
      title: StepLabel.IDENTIFICACAO_ADOLESCENTE,
      path: StepPath.IDENTIFICACAO_ADOLESCENTE,
    },
    {
      index: StepIndex.CIRCUNSTANCIAS,
      title: StepLabel.CIRCUNSTANCIAS,
      path: StepPath.CIRCUNSTANCIAS,
    },
    {
      index: StepIndex.NARRATIVAS,
      title: StepLabel.NARRATIVAS,
      path: StepPath.NARRATIVAS,
    },
    {
      index: StepIndex.RESUMO_OITIVA,
      title: StepLabel.RESUMO_OITIVA,
      path: StepPath.RESUMO_OITIVA,
    },
  ]

  return { hearingId, isFinalized, formSteps }
}
